import { DataAcquisitionsListFeature } from "../../features/data-acquisitions/index.js";

export function DataAcquisitionsPage() {
  return <DataAcquisitionsListFeature />;
}
